import context from 'lib/stores/context';

const setSidebarSelectedTab = (index: number) => {
  switch (context.activeView) {
    case 'worldwide':
      context.activeTabWorldwide = index;
      break;
    case 'country':
      context.activeTabCountries = index;
      break;
    case 'region':
      context.activeTabRegions = index;
      break;
    default:
      return 0;
  }
};

export default setSidebarSelectedTab;
